import { useSpring, animated } from 'react-spring';
import { ReactNode } from 'react';

interface PageTransitionProps {
  children: ReactNode;
  className?: string;
}

/**
 * PageTransition component
 * Adds a smooth fade-in and slide-up animation when a page loads
 */
export default function PageTransition({ children, className = '' }: PageTransitionProps) {
  const styles = useSpring({
    from: {
      opacity: 0,
      transform: 'translateY(20px)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0px)',
    },
    config: {
      tension: 280,
      friction: 60,
    },
  });

  return (
    <animated.div style={styles} className={className}>
      {children}
    </animated.div>
  );
}
